import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export function NotFound() {
	const location = useLocation()
	return (
		<div className="max-w-3xl mx-auto px-4 py-20 text-center">
			<div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-zcash-100 text-zcash-700 text-2xl font-bold mb-6">
				404
			</div>
			<h1 className="text-3xl font-bold text-gray-900 mb-2">That page is shielded from view.</h1>
			<p className="text-gray-600 mb-2">
				We couldn't find <code className="bg-gray-100 rounded px-1">{location.pathname}</code>.
			</p>
			<p className="text-sm text-gray-500 mb-8">
				If you got here from a link, please let us know. Otherwise pick a destination below.
			</p>
			<div className="flex flex-wrap justify-center gap-3">
				<Link
					to="/"
					className="px-5 py-3 rounded-md bg-zcash-600 text-white font-semibold hover:bg-zcash-700"
				>
					Go home
				</Link>
				<Link
					to="/privacy-punks"
					className="px-5 py-3 rounded-md border border-zcash-600 text-zcash-700 font-semibold hover:bg-zcash-50"
				>
					Mint a Privacy Punk
				</Link>
				<Link
					to="/how-it-works"
					className="px-5 py-3 rounded-md border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50"
				>
					How it works
				</Link>
			</div>
		</div>
	)
}

export default NotFound
